var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginuser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.5C4.5 20.3783 5.34285 18.3434 6.84315 16.8431C8.34344 15.3429 10.3783 14.5 12.5 14.5C14.6217 14.5 16.6566 15.3429 18.1569 16.8431C19.6571 18.3434 20.5 20.3783 20.5 22.5H18.5C18.5 20.9087 17.8679 19.3826 16.7426 18.2574C15.6174 17.1321 14.0913 16.5 12.5 16.5C10.9087 16.5 9.38258 17.1321 8.25736 18.2574C7.13214 19.3826 6.5 20.9087 6.5 22.5H4.5ZM12.5 13.5C9.185 13.5 6.5 10.815 6.5 7.5C6.5 4.185 9.185 1.5 12.5 1.5C15.815 1.5 18.5 4.185 18.5 7.5C18.5 10.815 15.815 13.5 12.5 13.5ZM12.5 11.5C14.71 11.5 16.5 9.71 16.5 7.5C16.5 5.29 14.71 3.5 12.5 3.5C10.29 3.5 8.5 5.29 8.5 7.5C8.5 9.71 10.29 11.5 12.5 11.5Z",
    fill: "#3070F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginuser);
export default __webpack_public_path__ + "static/media/Loginuser.a5faa58338af8bde729c880a06e3c570.svg";
export { ForwardRef as ReactComponent };